<template>
  <group>
    <div class="swiper-car1">
      <swiper :list="carImages" v-model="imageIndex" height="250px" imgKey="image_url" @on-index-change="changeImagesIndex"
       @on-click-list-item="clickListItem"></swiper>
    </div>
    <div class="swiper-car2">
      <cell :title="carInfo.car_model_name" class="v-cell-box v-mt">
        <div slot="after-title" class="vux-label-desc">
          <span v-html="auctionCarInfo"></span>
        </div>
        <div v-if="showPrice"  slot="after-title" class="vux-label-desc">
          <span style="float:left;">起拍价：{{startPrice ? (startPrice/ 1000000).toFixed(2) + '万元' : '--'}}</span>
          <div class="price-increase">
            <div class="price-increase-txt">加价幅度：{{(quoteIncrement / 100).toFixed(2) || '--' }}元</div>
          </div>
        </div>
      </cell>
    </div>
  </group>
</template>
<script>
import {
  Cell,
  Group,
  Swiper
} from '@lx-frontend/cvux'

export default {
  components: {
    Cell,
    Group,
    Swiper
  },
  props: {
    carImages: {
      type: Array,
      default() {
        return []
      }
    },
    carInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    startPrice: {
      type: Number,
      default: 0
    },
    showPrice: {
      type: Boolean,
      default: true
    },
    quoteIncrement: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      imageIndex: 1
    }
  },
  methods: {
    changeImagesIndex (index) {
      this.imageIndex = index
    },
    clickListItem(index) {
      this.$emit('click-swiper', index)
    }
  },
  computed: {
    auctionCarImages () {
      return (this.carInfo && this.carInfo.car_info && this.carInfo.car_info.images) || []
    },
    auctionCarInfo() {
      let info = this.carInfo
      let licensedAt = info.license_issued_on ? info.license_issued_on.substring(0, 4) : ''
      if (info) {
        return `${info.plate_number}&nbsp;&nbsp;|&nbsp;&nbsp;${licensedAt}年上牌&nbsp;&nbsp;|&nbsp;&nbsp;${(info.mileage / 10000).toFixed(2)}万公里 | ${info.emission_standard_name}`
      } else {
        return ''
      }
    }
  }
}

</script>
<style lang="less">
@import '../../../stylesheets/base/fn';
// 加价幅度
.price-increase {
  line-height:  48/@w2;
  margin-left: 19 / @w2;
  font-size: 26 / @w2;
  color: #ffffff;
  float: left;
}
// 加价幅度文字
.price-increase-txt {
  height: 40 / @w2;
  line-height: 40 / @w2;
  background-color: #a7a7b1;
  padding: 0 32/@w2 0 20/@w2;
  border-top-left-radius:20/@w2;
  border-top-right-radius:20/@w2;
  border-bottom-right-radius:20/@w2
}
</style>
